import React, { useState, useRef, forwardRef } from 'react';

export const  PrintCompoonet =  forwardRef((data, ref) => {
    return (
        <>
        <div ref={ref}>
          <h1>{`${data.children}`}</h1>
        </div>

    </>);
  });
    
 


  export default PrintCompoonet;
  